import { useEffect } from 'react';

import { useLocation, useSearchParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import { hasUTMInSearchParams } from 'utils/utm';

import { trackPageviewBreadcrumb } from 'dux/tracking/actions';
import { shouldShowBreadcrumbsPageviewUtms } from 'dux/featureFlags/selectors';

export const useUtmBreadcrumbs = () => {
  const [searchParams] = useSearchParams();
  const { pathname, search } = useLocation();
  const dispatch = useAppDispatch();
  // @ts-expect-error shouldShowBreadcrumbsPageviewUtms is not typed yet
  const breadcrumbsPageviewUtmsFlag = useAppSelector(shouldShowBreadcrumbsPageviewUtms);
  useEffect(() => {
    if (breadcrumbsPageviewUtmsFlag) {
      const hasUtm = hasUTMInSearchParams(searchParams);

      if (hasUtm) {
        // @ts-expect-error trackBreadcrumb is not typed yet
        dispatch(trackPageviewBreadcrumb(`${pathname}${search}`));
      }
    }
  }, [breadcrumbsPageviewUtmsFlag]);
};
